






























import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import { getters, mutations, actions } from "@/observables";
import STForm from "./STForm.vue";
import STMap from "./STMap.vue";
@Component({
  components: {
    STForm,
    STMap
  }
})
export default class TenderDispath extends Vue {
  @PropSync("visible", { type: Boolean }) dialog!: boolean;
  loading = false;
  route = [] as Array<TenderDispath.TenderDispathPoint>;
  tenderDispath = {} as TenderDispath.TenderDispath;
  canSendDispatch = true;
  sendSuccess = false;
  sendError = false;

  /* Computed */
  get units() {
    return getters.getUnidade();
  }

  get equipmentTDSelected() {
    return getters.getTDEquipmentSelected();
  }

  get warehouseTDSelected() {
    return getters.getTDWarehouseSelected();
  }

  get validBtnSend() {
    return (
      this.loading ||
      !this.canSendDispatch ||
      !this.route.length ||
      !(this.equipmentTDSelected && this.equipmentTDSelected.cdTenderTruck) ||
      !(this.warehouseTDSelected && this.warehouseTDSelected.id)
    );
  }

  /* Watch */
  @Watch("dialog") onOpen(newValue: boolean) {
    if (newValue) {
      actions.fetchEquipments(this.units);
    }
  }

  /* Methods */
  close() {
    this.dialog = false;
    this.clear();
    mutations.setWorkplaces([]);
  }

  async send() {
    this.tenderDispath.route = this.route;
    this.tenderDispath.tender = { id: this.equipmentTDSelected.cdTenderTruck };
    this.loading = true;
    this.sendError = false;
    try {
      await actions.dispatchTender(this.tenderDispath);
      this.clear();
      this.sendSuccess = true;
      setTimeout(() => {
        this.dialog = false;
        this.sendSuccess = false;
      }, 2000);
    } catch (e) {
      console.error(e);
      this.sendError = true;
      setTimeout(() => {
        this.sendError = false;
      }, 5000);
    } finally {
      this.loading = false;
    }
  }

  clear() {
    this.tenderDispath = {} as TenderDispath.TenderDispath;
    mutations.setTDEquipmentSelected({} as Tender.Equipamento);
    mutations.setTDWarehouseSelected({} as TenderMixOperator.Warehouse);
    this.route = [];
  }

  /* Hooks */
  mounted() {
    this.sendSuccess = false;
  }
}
